import React, {useEffect, useRef, useState} from "react";
import Hero from "../../../components/home/Hero/Hero";
import { useTranslation } from "react-i18next";
import './Home.css'
import axios from "axios";
import whiteArrowIcon from '../../../assets/images/Home/whiteArrow.svg'
import ruinsImg from '../../../assets/images/Home/ruins.png'
import lakeImg from '../../../assets/images/Home/lake.png'
import {Link} from "react-router-dom";
import useLangLink from "../../../utils/useLangLink";
import Discover from "../../../components/Discover/Discover";
import OherPractices from "../../../components/OtherPractices/OherPractices";
import SEO from "../../../utils/SEO";

export default function Home() {

    const { t } = useTranslation();
    const lp = useLangLink();
    const tp = (k, d) => t(`pages.home.${k}`, d);

    const readyMadeLicenseArr = tp('business.licenses', { returnObjects: true }) || []

    const readyMadeConpaniesArr = tp('business.companies', { returnObjects: true }) || []

    const [isExpandedLicenses, setIsExpandedLicenses] = useState(false);
    const [isExpandedCompanies, setIsExpandedCompanies] = useState(false);
    const [isMobile, setIsMobile] = useState(false);

    useEffect(() => {
        const checkIfMobile = () => {
            // 500px - ваш порог для мобильных устройств
            setIsMobile(window.innerWidth <= 500);

            // Сбрасываем состояния при переходе на десктоп
            if (window.innerWidth > 500) {
                setIsExpandedLicenses(false);
                setIsExpandedCompanies(false);
            }
        };

        checkIfMobile();
        window.addEventListener('resize', checkIfMobile);

        return () => window.removeEventListener('resize', checkIfMobile);
    }, []);

    const shouldShowAllLicenses = !isMobile || isExpandedLicenses;
    const licensesToShow = shouldShowAllLicenses
        ? readyMadeLicenseArr
        : readyMadeLicenseArr.slice(0, 5);


    const shouldShowAllCompanies = !isMobile || isExpandedCompanies;
    const companiesToShow = shouldShowAllCompanies
        ? readyMadeConpaniesArr
        : readyMadeConpaniesArr.slice(0, 5);

    const toggleExpandLicenses = () => {
        setIsExpandedLicenses(!isExpandedLicenses);
    };

    const toggleExpandCompanies = () => {
        setIsExpandedCompanies(!isExpandedCompanies);
    };


    const formRef = useRef(null);
    const [status, setStatus] = useState({type: "idle", msg: ""});

    const onSubmit = async (e) => {
        e.preventDefault();
        const form = formRef.current;
        if (!form) return;

        const fullName = form.full_name?.value.trim() || "";
        const email = form.subscriber_email?.value.trim() || "";
        const message = form.message?.value.trim() || "";
        const privacyChecked = form.privacy_agreed?.checked;

        // honeypot
        const formData = new FormData(form);
        const data = Object.fromEntries(formData.entries());
        delete data.company;

        if (form.company && form.company.value) {
            return;
        }

        if (!/^\S+@\S+\.\S+$/.test(email)) {
            setStatus({type: "error", msg: tp('form.errEmail')});
            return;
        }

        if (!fullName) {
            setStatus({type: "error", msg: tp('form.errName')});
            return;
        }

        if (!privacyChecked) {
            setStatus({
                type: "error",
                msg: tp('form.errPrivacy'),
            });
            return;
        }

        setStatus({type: "loading", msg: tp('form.loading')});

        try {
            const response = await axios.post('https://assembly.tehnik.tech/api/send_form/from', {
                project: 'offshoreadvisory',
                subject: '/',
                data: data // все данные формы
            }, {

                headers: {
                    'Content-Type': 'application/json',

                }
            });

            form.reset();
            if (response.status === 200) {
                setStatus({
                    type: "success",
                    msg: tp('form.success'),
                });
            }

        } catch (err) {
            console.error(err);
            setStatus({
                type: "error",
                msg: tp('form.error'),
            });
        }
    };


    return (
        <main className='main'>
            <SEO
                title={tp('seo.title')}
                description={tp('seo.description')}
                keywords={tp('seo.keywords')}
                url="/"
            />
            <Hero/>
            <div className='keys-sucess-deal-container'>
                <div className="keys-content-row">
                    <Link className="keys-content-item keys-content-item-link" to={lp("/igaming-gambling-western-sahara")}>
                        <h3>{tp('cards.ws.city')}</h3>
                        <div>
                            <p>
                                {tp('cards.ws.text')}
                            </p>
                        </div>
                        <span>
                            15,000 USD
                        </span>
                    </Link>
                    <Link className="keys-content-item keys-content-item-link" to={lp("/gaming-license-anjouan")}>
                        <h3>{tp('cards.anjouan.city')}</h3>
                        <div>
                            <p>
                                {tp('cards.anjouan.text')}
                            </p>
                        </div>
                        <span>
                            19,000 USD
                        </span>
                    </Link>
                    <Link className="keys-content-item keys-content-item-link" to={lp("/forex-brokerage-license-cyprus")}>
                        <h3>{tp('cards.cyprus.city')}</h3>
                        <div>
                            <p>
                                {tp('cards.cyprus.text')}
                            </p>
                        </div>
                        <span>
                            40,000 USD
                        </span>
                    </Link>
                    <Link className="keys-content-item keys-content-item-link" to={lp("/gaming-license-mwali")}>
                        <h3>{tp('cards.mwali.city')}</h3>
                        <div>
                            <p>
                                {tp('cards.mwali.text')}
                            </p>
                        </div>
                        <span>
                            17,000 USD
                        </span>
                    </Link>
                </div>
            </div>
            <div className="offshore-zone-background">
                <div className="offshore-content">
                    <div className="ofsshore-left">
                        <h2>
                            {tp('offer.title')}
                        </h2>
                        <Link to={lp('/newsletter')} className="contact-us-black-button">
                            {tp('offer.contact')}
                            <img src={whiteArrowIcon}/>
                        </Link>

                    </div>
                    <div className="offshore-right">
                        <div className="offshore-zone-item-descr">
                            {tp('offer.p1')}
                        </div>
                        <div className="offshore-zone-item-descr">
                            {tp('offer.p2')}
                        </div>
                        <div className="offshore-zone-item-descr">
                            {tp('offer.p3')}
                        </div>
                        <div className="offshore-zone-item-descr">
                            {tp('offer.p4')}
                        </div>
                    </div>
                </div>
            </div>
            <div className="loocking-information-container">
                <div className="loocking-information-upper">
                    <div className="loocking-information-item">
                        <h3 className="loocking-information-item-title">
                            80+
                        </h3>
                        <span>
                            {tp('stats.countries')}
                        </span>
                    </div>
                    <div className="loocking-information-item">
                        <h3 className="loocking-information-item-title">
                            1000+
                        </h3>
                        <span>
                            {tp('stats.clients')}
                        </span>
                    </div>
                    <div className="loocking-information-item">
                        <h3 className="loocking-information-item-title">
                            10+
                        </h3>
                        <span>
                            {tp('stats.industries')}
                        </span>
                    </div>
                    <div className="loocking-information-item">
                        <h3 className="loocking-information-item-title">
                            4
                        </h3>
                        <span>
                           {tp('stats.services')}
                        </span>
                    </div>
                </div>
                <div className="loocking-information-bottom">
                    <h4 className="loocking-information-title">
                        {tp('moreInfo.title')}
                    </h4>
                    <Link to={lp('/newsletter')} className="contact-us-white-button">
                        {tp('moreInfo.button')}

                    </Link>
                </div>
            </div>
            <div className="business-for-sale-background">
                <div className="business-content">
                    <h2 className="business-main-title">
                        {tp('business.title')}
                    </h2>
                    <div className="business-pre-title-wrapper">
                        <p className="business-pre-title">
                            {tp('business.subtitle')}
                        </p>
                    </div>
                    <div className="business-keys-row">
                        <div className="business-keys-left">
                            <h3 className="business-key-title">
                                {tp('business.licensesTitle')}
                            </h3>

                            <div className="business-keys-items">
                                {licensesToShow.map((el, index) => (
                                    <div className="business-key-item" key={index}>
                                        {el}
                                    </div>
                                ))}
                            </div>

                            {/* Кнопка для лицензий - показывается только на мобилках если элементов больше 5 */}
                            {isMobile && readyMadeLicenseArr.length > 5 && (
                                <button
                                    className="show-more-button"
                                    onClick={toggleExpandLicenses}
                                >
                                    {isExpandedLicenses ? tp('business.showLess') : tp('business.showMore')}
                                </button>
                            )}
                        </div>

                        <div className="business-keys-right">
                            <h3 className="business-key-title">
                                {tp('business.companiesTitle')}
                            </h3>

                            <div className="business-keys-items">
                                {companiesToShow.map((el, index) => (
                                    <div className="business-key-item" key={index}>
                                        {el}
                                    </div>
                                ))}
                            </div>

                            {/* Кнопка для компаний - показывается только на мобилках если элементов больше 5 */}
                            {isMobile && readyMadeConpaniesArr.length > 5 && (
                                <button
                                    className="show-more-button"
                                    onClick={toggleExpandCompanies}
                                >
                                    {isExpandedCompanies ? tp('business.showLess') : tp('business.showMore')}
                                </button>
                            )}
                        </div>
                    </div>
                </div>
            </div>
            <Discover/>
            <OherPractices/>
            <div className="contact-background">
                <div className="email-block-container">
                    <h2 className="email-title">{tp('form.title')}</h2>
                    <div>
                        <form ref={formRef} onSubmit={onSubmit} noValidate>
                            <div className="input-wrapper">
                                <input
                                    name="full_name"
                                    placeholder={tp('form.fullName')}
                                    required
                                />
                            </div>
                            <div className="input-wrapper">
                                <input
                                    name="subscriber_email"
                                    type="email"
                                    placeholder={tp('form.email')}
                                    required
                                />
                            </div>
                            <div className="textarea-wrapper">
                        <textarea
                            name="message"
                            placeholder={tp('form.brief')}
                        />
                            </div>

                            {/* honeypot */}
                            <input
                                type="text"
                                name="company"
                                tabIndex={-1}
                                autoComplete="off"
                                className="cf-hp"
                                aria-hidden="true"
                            />

                            <div className="agree-privacy">
                                <div className="agree-checkbox">
                                    <input type="checkbox" name="privacy_agreed"/>
                                    <p>
                                        {tp('form.agree')} <Link to="">{tp('form.privacy')}</Link>
                                    </p>
                                </div>
                                <button
                                    type="submit"
                                    className="black-btn"
                                    disabled={status.type === "loading"}
                                >
                                    {status.type === "loading" ? tp('form.sending') : tp('form.submit')}
                                    <img src={whiteArrowIcon} alt=""/>
                                </button>
                            </div>

                            <div
                                className={`contact-status contact-status--${status.type}`}
                                aria-live="polite"
                            >
                                {status.msg}
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            <div className="our-blog-container">
                <div className="our-block-upper">
                    <h2>
                        {tp('blog.title')}
                    </h2>
                    <Link to='/blogs' className="black-btn" style={{maxWidth: '180px'}}>
                        {tp('blog.readMore')}
                        <img src={whiteArrowIcon}/>
                    </Link>
                </div>


                <div className="blog-cards-row">
                    <Link to='/western-sahra-gaming-license-blog' className="blog-item-element">
                        <div>
                            <div className="blog-img-wrapper">
                                <img src={ruinsImg}/>
                            </div>
                            <h3 className="blog-item-title">
                                {tp('blog.posts.0.title')}
                            </h3>
                            <div className="blog-item-descr-wrapper">
                                <p className="blog-item-descr">
                                    {tp('blog.posts.0.descr')}
                                </p>
                            </div>
                            <div className="aditional-content">
                                <div className="blog-item-date">
                                    2025.10.01
                                </div>
                                <Link to='/western-sahra-gaming-license-blog' className="black-btn">
                                    {tp('blog.readMore')}

                                </Link>
                            </div>
                        </div>
                    </Link>
                    <Link to='/anjouan-gaming-license-blog'>
                        <div className="blog-item-element">
                            <div className="blog-img-wrapper">
                                <img src={lakeImg}/>
                            </div>
                            <h3 className="blog-item-title">
                                {tp('blog.posts.1.title')}
                            </h3>
                            <div className="blog-item-descr-wrapper">
                                <p className="blog-item-descr">
                                    {tp('blog.posts.1.descr')}
                                </p>
                            </div>
                            <div className="aditional-content">
                                <div className="blog-item-date">
                                    2025.10.01
                                </div>
                                <Link to='/anjouan-gaming-license-blog' className="black-btn">
                                    {tp('blog.readMore')}
                                </Link>
                            </div>
                        </div>
                    </Link>
                </div>
            </div>
            {/* <OurServices/>
            <ContactForm/>
            <NewsletterPopup/> */}
        </main>

    )
}